module.exports = __webpack_public_path__ + "static/media/hololed.a3129f09.png";